// extracted by mini-css-extract-plugin
export var chevron = "_3g-2";
export var chevronCollapsed = "_3g-3";
export var collapsibleHeader = "_3g-1";
export var container = "_3g-0";